export default "__VITE_ASSET__DvgN$c7M__"